import React, { useRef } from 'react'
import PropTypes from 'prop-types'

// Utils
import { useOutsideAlerter } from 'common/utils/outsideAlerter'
import { useAnimatedMount } from 'common/utils/render'

// Styled Elements
import { ModalBackdrop, ModalWrapper, ModalContainer } from './Modal.elements'

function Modal(props) {
  // Destructure
  const { children, isOpen, toggle, ...rest } = props

  // Refs
  const wrapperRef = useRef()

  // Hooks
  useOutsideAlerter(wrapperRef, () => {
    if (isOpen === true) {
      toggle()
    }
  })
  const { shouldRender, animateIn } = useAnimatedMount(isOpen, 300)

  return shouldRender ? (
    <ModalBackdrop isOpen={animateIn}>
      <ModalWrapper {...rest} isOpen={animateIn}>
        <ModalContainer ref={wrapperRef} isOpen={animateIn}>
          {children}
        </ModalContainer>
      </ModalWrapper>
    </ModalBackdrop>
  ) : null
}

// Default Props
Modal.defaultProps = {
  children: '',
  isOpen: false,
  toggle: () => {},
}

// Proptypes Validation
Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
}

export default Modal
